import DragScroll from './DragScroll.component';

export default DragScroll;